import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { CREATE_FACILITY_HOLIDAY, CREATE_FACILITY_HOLIDAY_SUCCESS, CREATE_FACILITY_HOLIDAY_ERROR } from '../../actions';
import apiCall from '../../../apiCall';
import cogoToast from 'cogo-toast';

function* createFacilityHoliday({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/golf-inventory/facility-holiday/create`,
      method: 'POST',
      data: payload?.data,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);
      yield put({
        type: CREATE_FACILITY_HOLIDAY_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: CREATE_FACILITY_HOLIDAY_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_FACILITY_HOLIDAY_ERROR, payload: error });
  }
}

export function* watchCreateFacilityHoliday() {
  yield takeEvery(CREATE_FACILITY_HOLIDAY, createFacilityHoliday);
}

function* createFacilityHolidaySaga() {
  yield all([fork(watchCreateFacilityHoliday)]);
}

export default createFacilityHolidaySaga;
